import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appFileUpload]'
})
export class FileUploadDragDropDirective {

  // fonte: https://stackblitz.com/edit/file-upload-drag-n-drop-ecfyqf?file=src%2Fapp%2Ffile-drag-n-drop.directive.ts

  @Output() private filesChangeEmiter : EventEmitter<File[]> = new EventEmitter();
  @HostBinding('style.background') private background = '#ffffff';
  @HostBinding('style.border') private borderStyle = '1px solid';
  @HostBinding('style.border-color') private borderColor = '#CCCCCC';
  @HostBinding('style.border-radius') private borderRadius = '5px';
  // @HostBinding('style.border-top-left-radius') private borderTopLeftRadius = '5px';
  // @HostBinding('style.border-top-right-radius') private borderTopRightRadius = '5px';

  constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(evt){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'lightgray';
    this.borderColor = '#aba5ab';
    this.borderStyle = 'solid 3px';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#ffffff';
    this.borderColor = '#CCCCCC';
    this.borderStyle = 'solid 1px';
  }

  @HostListener('drop', ['$event']) public onDrop(evt){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#ffffff';
    this.borderColor = '#CCCCCC';
    this.borderStyle = 'solid 1px';
    let files = evt.dataTransfer.files;
    let valid_files : Array<File> = files;
    this.filesChangeEmiter.emit(valid_files);
  }
}
